var normalizeComponent = require("!../../node_modules/vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = require("!!babel-loader?{\"cacheDirectory\":true,\"presets\":[[\"env\",{\"modules\":false,\"targets\":{\"browsers\":[\"> 2%\"],\"uglify\":true}}]],\"plugins\":[\"transform-object-rest-spread\",[\"transform-runtime\",{\"polyfill\":false,\"helpers\":false}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Page-04.vue")
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./_vue/components/Page-04.vue
// module id = 24
// module chunks = 0